import * as carts from "./carts";
import * as categories from "./categories";
import * as orders from "./orders";
import * as products from "./products";
import * as purchases from "./purchases";
import * as inquires from "./inquires";
import * as reviews from "./reviews";
import * as expectations from "./expectations";
import * as setting from "./setting";

export const shop = {
    ...carts,
    ...categories,
    ...orders,
    ...products,
    ...purchases,
    ...inquires,
    ...reviews,
    ...expectations,
    ...setting
}
